'use client';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow, TableCell } from '@/components/ui/table';

interface AuditTrailTableSkeletonProps {
  rows?: number;
}

/**
 * AuditTrailTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export function AuditTrailTableSkeleton({ rows = 10 }: AuditTrailTableSkeletonProps) {
  return (
    <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
      <>
        {Array.from({ length: rows }, (_, index) => (
          <TableRow key={index}>
            {/* Created At (two-line: date + year) */}
            <TableCell className="w-[130px]">
              <div className="flex flex-col gap-0.5 py-1">
                <Skeleton height={14} width={90} />
                <Skeleton height={12} width={40} />
              </div>
            </TableCell>

            {/* Action */}
            <TableCell className="w-[220px]">
              <Skeleton height={14} width={170} />
            </TableCell>

            {/* Operation */}
            <TableCell className="w-[110px]">
              <Skeleton height={14} width={70} />
            </TableCell>

            {/* Entity (two-line: label + type) */}
            <TableCell className="w-[180px]">
              <div className="flex flex-col gap-0.5 py-1">
                <Skeleton height={14} width={140} />
                <Skeleton height={12} width={100} />
              </div>
            </TableCell>

            {/* Actor (two-line: name + email) */}
            <TableCell className="w-[200px]">
              <div className="flex flex-col gap-0.5 py-1">
                <Skeleton height={14} width={150} />
                <Skeleton height={12} width={120} />
              </div>
            </TableCell>

            {/* Realm Badge */}
            <TableCell className="w-[130px]">
              <Skeleton height={20} width={70} borderRadius="0.375rem" />
            </TableCell>

            {/* Store */}
            <TableCell className="w-[160px]">
              <Skeleton height={14} width={120} />
            </TableCell>
          </TableRow>
        ))}
      </>
    </SkeletonTheme>
  );
}
